import {
  AUTHORIZATION_CLIENT_ID,
  HOST_URL,
  MARKETPLACE_CODE_CHALLENGE,
  MARKETPLACE_DEV_CONTEXT,
  MARKETPLACE_GWT,
  MARKETPLACE_GWT_ID,
  MARKETPLACE_OAUTH2_STATE,
  REDIRECT_URL,
  MARKETPLACE_DEV_DEACTIVATED,
} from '@marketplace/common';
import { TAPIFetchDeveloperContext } from '@marketplace/api';
import { ROUTE_DEVELOPER_DASHBOARD } from '@developer/constants';

import { TAuthHookParams, TParsedToken, USER_ROLES, USER_AD_GROUPS } from './auth.types';

export const OAuth2Verification = (params: TAuthHookParams) => {
  const token = localStorage.getItem(MARKETPLACE_GWT);
  const query = new URLSearchParams(params.search);
  const authCode = query.get('code');
  const state = query.get('state');

  const oauth2State = localStorage.getItem(MARKETPLACE_OAUTH2_STATE);

  if (!(!token && authCode && state === oauth2State)) {
    console.info('== AUTHORIZATION ==', 'Did Not Pass OAuth 2.0 Verification');
  }

  return !token && authCode && state === oauth2State;
};

export const getOAuthToken = async (
  params: TAuthHookParams,
  fetchToken: any
) => {
  const query = new URLSearchParams(params.search);
  const authCode = query.get('code') || '';
  const code_verifier = localStorage.getItem(MARKETPLACE_CODE_CHALLENGE);
  const body = new URLSearchParams({
    grant_type: 'authorization_code',
    code: authCode,
    client_id: AUTHORIZATION_CLIENT_ID || '',
    code_verifier: code_verifier || '',
    redirect_uri: `${HOST_URL}/${REDIRECT_URL}`,
    scope: 'openid',
  });

  let token = null;
  let id_token = null;
  const tokenResponse = await fetchToken.post('/token', body);

  if (tokenResponse.status === 'OK') {
    token = fetchToken.response.data['access_token'];
    id_token = fetchToken.response.data['id_token'];

    if (token) {
      localStorage.setItem(MARKETPLACE_GWT, token);
    }
    if (id_token) {
      localStorage.setItem(MARKETPLACE_GWT_ID, id_token);
    }
  }

  if (!token) {
    console.info('== AUTHORIZATION ==', 'Did Not Get OAuth 2.0 Token ');
  }

  return token;
};

export const getDeveloperContext = async (
  developerContextAPI: TAPIFetchDeveloperContext,
  token: string | null
): Promise<boolean> => {
  const developerContext = localStorage.getItem(MARKETPLACE_DEV_CONTEXT);

  if (!developerContext) {
    const developerContextData =
      await developerContextAPI.fetchDeveloperContext(token);

    if (developerContextData?.data) {
      localStorage.setItem(
        MARKETPLACE_DEV_CONTEXT,
        JSON.stringify(developerContextData?.data)
      );

      return true;
    }

    if (
      developerContextData?.errors &&
      developerContextData?.errors[0].code === '4006'
    ) {
      localStorage.setItem(MARKETPLACE_DEV_DEACTIVATED, 'true');

      return false;
    }
  } else {
    return true;
  }

  console.info('== AUTHORIZATION ==', 'Did Not Get Developers Context');

  return false;
};

export const redirectTo = (parsedToken: TParsedToken) => {
  if (parsedToken) {
    if (parsedToken?.role === USER_ROLES.USER || parsedToken?.groups?.includes(USER_AD_GROUPS.AD_GRP_USER))  {
      window.location.href = ROUTE_DEVELOPER_DASHBOARD;
    } else if (parsedToken?.role === USER_ROLES.ADMIN || 
        (parsedToken?.groups?.includes(USER_AD_GROUPS.AD_GRP_ADMIN) || parsedToken?.groups?.includes(USER_AD_GROUPS.AD_GRP_SUPPORT))) {
      window.location.href = '/admin';
    }
  }

  console.info('== AUTHORIZATION ==', 'Did Not Redirect');
};
